import { useGet } from '../useGet';
import { API_URL } from '~/utils';

export function useObterTotalFluxos() {
  return useGet({
    url: `${API_URL}/compromissos/obter-total-fluxos`,
    config: {
      getAccessToken: true,
      timeout: 120000,
    },
  });
}
